// extracted by mini-css-extract-plugin
export default {"wrapper":"SocialView_wrapper__nF5ch","table":"SocialView_table__ejXY5","emptyListView":"SocialView_emptyListView__cOL6M"};